var _filter, _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-2qgrgz",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r1a:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21,
    width: 20,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_651_210175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_651_210175",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r1a:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 20.9102,
    y1: 4.5158,
    y2: 20.7203
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Ui-outlineFilter",
    filter: "url(#:r1a:-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    clipRule: "evenodd",
    d: "m12 3c-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9 4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9zm-.7714 1.58228c-1.46209.15026-2.79894.72292-3.88654 1.59392 1.17698 1.38561 1.94245 3.13345 2.10547 5.0524h1.78107zm-4.9885 2.68109c.90733 1.10187 1.50403 2.46764 1.65781 3.96523h-3.31563c.1539-1.49755.75095-2.86372 1.65782-3.96523zm1.65781 5.50803h-3.31563c.1539 1.4976.75095 2.8637 1.65783 3.9652.90733-1.1019 1.50401-2.4676 1.6578-3.9652zm9.86209-5.50797c.9068 1.1015 1.5038 2.46765 1.6577 3.96517h-3.3155c.1538-1.49757.7504-2.86332 1.6578-3.96517zm-1.102-1.08719c-1.177 1.38561-1.9424 3.13343-2.1054 5.05236h-1.7812v-6.64632c1.4621.15026 2.799.72294 3.8866 1.59396zm-2.1054 6.59516h-1.7812v6.6463c1.4621-.1502 2.799-.7229 3.8866-1.5939-1.177-1.3857-1.9424-3.1335-2.1054-5.0524zm3.2073 3.9652c.9069-1.1015 1.5039-2.4677 1.6578-3.9652h-3.3155c.1538 1.4976.7504 2.8633 1.6577 3.9652zm-6.5313 2.6811v-6.6463h-1.78108c-.16302 1.919-.92848 3.6668-2.10544 5.0524 1.08759.871 2.42444 1.4437 3.88652 1.5939z",
    fill: "#ffca00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 3c-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9 4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9zm-.7714 1.58228c-1.46209.15026-2.79894.72292-3.88654 1.59392 1.17698 1.38561 1.94245 3.13345 2.10547 5.0524h1.78107zm-4.9885 2.68109c.90733 1.10187 1.50403 2.46764 1.65781 3.96523h-3.31563c.1539-1.49755.75095-2.86372 1.65782-3.96523zm1.65781 5.50803h-3.31563c.1539 1.4976.75095 2.8637 1.65783 3.9652.90733-1.1019 1.50401-2.4676 1.6578-3.9652zm9.86209-5.50797c.9068 1.1015 1.5038 2.46765 1.6577 3.96517h-3.3155c.1538-1.49757.7504-2.86332 1.6578-3.96517zm-1.102-1.08719c-1.177 1.38561-1.9424 3.13343-2.1054 5.05236h-1.7812v-6.64632c1.4621.15026 2.799.72294 3.8866 1.59396zm-2.1054 6.59516h-1.7812v6.6463c1.4621-.1502 2.799-.7229 3.8866-1.5939-1.177-1.3857-1.9424-3.1335-2.1054-5.0524zm3.2073 3.9652c.9069-1.1015 1.5039-2.4677 1.6578-3.9652h-3.3155c.1538 1.4976.7504 2.8633 1.6577 3.9652zm-6.5313 2.6811v-6.6463h-1.78108c-.16302 1.919-.92848 3.6668-2.10544 5.0524 1.08759.871 2.42444 1.4437 3.88652 1.5939z",
    fill: "url(#:r1a:-gradient)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m12 2.5c-5.24671 0-9.5 4.25329-9.5 9.5 0 5.2467 4.25329 9.5 9.5 9.5 5.2467 0 9.5-4.2533 9.5-9.5 0-5.24671-4.2533-9.5-9.5-9.5zm-2.10431 8.2286c-.22244-1.66143-.87442-3.18722-1.83934-4.46088.78864-.54369 1.69463-.92858 2.67225-1.10904v5.56992zm-4.73701 0c.17739-.961.55233-1.8528 1.08146-2.63195.52933.77927.90414 1.67093 1.08142 2.63195zm1.08146 5.1748c-.52913-.7792-.90407-1.671-1.08146-2.632h2.16288c-.17728.961-.55209 1.8527-1.08142 2.632zm10.43836-5.1748c.1773-.961.5521-1.85263 1.0814-2.63188.5291.77913.904 1.67091 1.0814 2.63188zm-3.4071 0v-5.56992c.9776.18046 1.8837.56537 2.6723 1.10908-.9649 1.27365-1.6169 2.79944-1.8393 4.46084zm0 8.1127v-5.5699h.833c.2224 1.6614.8744 3.1872 1.8393 4.4609-.7887.5437-1.6947.9286-2.6723 1.109zm3.4071-5.5699h2.1628c-.1774.961-.5523 1.8528-1.0814 2.6319-.5293-.7793-.9041-1.6709-1.0814-2.6319zm-5.9499 0v5.5699c-.97762-.1804-1.8836-.5653-2.67224-1.109.96491-1.2737 1.61688-2.7995 1.83933-4.4609z",
    stroke: "#5800e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.dc571d91b9c71907e93971b55702dabf.svg";
export { ForwardRef as ReactComponent };